<template>
	<z-paging ref="paging" class="z-paging page_bg" v-model="useList" @query="getInfo"
		:hide-loading-more-when-no-more-by-limit="5">
		<view class="list-item flex-row" v-for="item in useList">
			<view class="flex-col group_3">
				<text class="text_1">{{item.useOrRecharge == 'admin' ? '管理员充值' : '充值学习币'}}</text>
				<text class="text_2">{{item._add_time_str}}</text>
			</view>
			<text class="text_3">+{{item.number}}</text>
		</view>
	</z-paging>
</template>

<script>
	var that; // 当前页面对象
	var vk; // vk依赖
	export default {
		data() {
			// 页面数据变量
			return {
				useList: []
			}
		},
		// 监听 - 页面每次【加载时】执行(如：前进)
		onLoad(options = {}) {
			that = this;
			vk = that.vk;
			that.init(options)
		},
		// 监听 - 页面【首次渲染完成时】执行。注意如果渲染速度快，会在页面进入动画完成前触发
		onReady() {},
		// 监听 - 页面每次【显示时】执行(如：前进和返回) (页面每次出现在屏幕上都触发，包括从下级页面点返回露出当前页面)
		onShow() {},
		// 监听 - 页面每次【隐藏时】执行(如：返回)
		onHide() {},
		// 函数
		methods: {
			// 页面数据初始化函数
			init(options) {},
			getInfo(pageIndex, pageSize) {
				vk.callFunction({
					url: 'client/accout/kh/getCoinAndList',
					title: '请求中...',
					data: { pageIndex, pageSize, need_user_info: true, recharge: true },
					success: function(data) {
						that.$refs.paging.complete(data.rows);
					}
				})
			}
		},
	}
</script>

<style lang="scss" scoped>
	.list-item {
		padding: 30rpx 20rpx;
		border-bottom: 1px solid #F0F0F0;

		.group_3 {
			flex: 1 1 auto;

			.text_1 {
				color: rgb(51, 51, 51);
				font-size: 30rpx;
				line-height: 36rpx;
				white-space: nowrap;
			}

			.text_2 {
				margin-top: 16rpx;
				color: rgb(153, 153, 153);
				font-size: 24rpx;
				line-height: 29rpx;
				white-space: nowrap;
			}
		}

		.text_3 {
			margin-left: 40rpx;
			align-self: center;
			color: rgb(51, 51, 51);
			font-size: 30rpx;
			line-height: 36rpx;
			white-space: nowrap;
		}
	}
</style>
